import { isNumericId } from "./idValidation";

export const validateRoleId = (roleId: string | number): boolean => {
	return isNumericId(roleId);
};

const roleValidation = {
	validateRoleId
};

export default roleValidation;
